module.exports = __webpack_public_path__ + "static/media/aa1000.2a6657ee.svg";